import { useEffect, useState } from "react";
import Popup from "../../components/Popup";
import {Table, Pagination, Button, Tag} from "omoplay";
import MiniMenu from "../form/MiniMenu";
import {deleteEvent, getEventList} from "../../api/event/event.api";
import GenericBoard from "../form/GenericBoard";

const EventList = () => {
  const [page, setPage] = useState(1);
  const [eventList, setEventList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [deleteEventId, setDeleteEventId] = useState(undefined);
  const [tableData, setTableData] = useState([])
  const [openMenuId, setOpenMenuId] = useState(null)

  const rowSize = 10

  useEffect(() => {
    getEventList(page, rowSize).then(({data}) => {
      setEventList(data.events);
      setTotalPages(data.count);
    })
  }, [page])

  function goEdit(eventId) {
    window.location.href = `/event/edit?id=${eventId}`
  }

  useEffect(() => {
    setTableData(eventList.map((event) => {
      let typeBadge;
      if (event.type === "skip") {
        typeBadge = <Tag color="warning">바로당첨</Tag>
      } else if (event.type === "friends") {
        typeBadge = <Tag color="info">친구초대</Tag>
      } else if (event.type === "lottery") {
        typeBadge = <Tag color="success">추첨</Tag>
      } else if (event.type === "roulette") {
        typeBadge = <Tag color="default">룰렛</Tag>
      }

      return [
        <div className="flex-center-all h-full">
          <div>
            {
              typeBadge
            }
          </div>
        </div>,
        <div className="flex-col flex justify-center h-full">
          <div className="text-primary pointer" onClick={() => goEdit(event.id)}>{event.name}</div>
        </div>,
        <div className="flex-col justify-center gap-2 h-full">
          {
            event.benefits?.map(benefit => {
              return (
                  <div>
                    <Tag>
                      {benefit.name}
                      ({benefit.winningPercent}%)
                    </Tag>
                  </div>
              )
            })
          }
        </div>,
        <div className="flex-align-center h-full text-center">
          {event.modifiedAt}
        </div>,
        <div className="flex-center-all h-full">
          <MiniMenu
              id={event.id}
              openMenuId={openMenuId}
              setOpenMenuId={setOpenMenuId}
              onClickEdit={() => goEdit(event.id)}
              onClickDelete={() => setDeleteEventId(event.id)}
              disabledDelete={event.used}
          />
        </div>
      ]
    }))
  }, [eventList, openMenuId])

  const handleDelete = () => {
    setDeleteEventId(undefined)
    /* 🔴 서버가 거부하면 **사유를 payload 로** 돌려준다(성공 = "ok"). 2026-09-23 —
       프로젝트에 연결된 이벤트는 삭제되지 않는다(진행중 프로젝트면 QR 스캔이 500 이 나던 경로).
       응답을 흘려버리고 새로고침하면 "지웠는데 그대로 있다" 는 조용한 실패가 된다. */
    deleteEvent(deleteEventId).then(({data}) => {
      if (data && data !== "ok") {
        alert(data)
        return
      }
      window.location.reload()
    })
  };

  const headers = [
    { name: "타입", width: "120px", align: "center" },
    { name: "이벤트" },
    { name: "혜택" },
    { name: "업데이트 날짜", width: "120px" },
    { name: "", align: "center", width: "80px" },
  ];

  return (
    <>
      <div className="w-full">
        <div className="flex w-100 items-center">
          <div className="w-full flex justify-between items-center">
            <div>
              총 <span className="font-bold text-primary">{totalPages}</span>개
            </div>
            <Button variants="primary" value="+ 이벤트 추가" onClick={() => {
              window.location.href = "/event/edit"
            }} />
          </div>
        </div>
        <div className="flex-col py-2">
          <GenericBoard items={tableData} columns={[
            { align: 'left', width: 'w-16' },
            { align: 'left', flex: true },
            { align: 'left', flex: true },
            { align: 'right', width: 'w-32' },
            { align: 'right' }
          ]} />
          <div className="flex justify-center" style={{marginTop: "24px"}}>
            <Pagination pageSize={rowSize} totalCount={totalPages} currentPage={page} onPaging={(page) => setPage(page)} />
          </div>
        </div>
      </div>
      {deleteEventId && (
        <Popup
          title={"정말 삭제하시겠습니까?"}
          buttons={[
            { label: "취소", onClick: () => setDeleteEventId(undefined) },
            { label: "확인", type: "info", onClick: () => handleDelete() },
          ]}
        />
      )}
    </>
  );
};
export default EventList;
